var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"generic-image",style:(_vm.customStyle),attrs:{"src":_vm.src,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }